module.exports = {
	"title": {
		"artist": "Słuchaj {artistName} w Qobuz",
		"album": "Słuchaj albumu {albumName} od {artistName} w Qobuz",
		"track": "Słuchaj utworu {trackName} od {artistName} w Qobuz",
		"playlist": "Słuchaj playlisty {playlistName} od {ownerName} w Qobuz",
		"story": "Przeczytaj ten artykuł w Qobuz"
	},
	"buttons": {
		"listen": "Słuchaj w Qobuz",
		"buy": "Kup",
		"share": "Udostępnij",
		"download": "Wypróbuj za darmo",
		"readmore": "Czytaj więcej",
		"showless": "Pokaż mniej",
		"showmore": "Pokaż więcej",
		"morealbums": "Więcej albumów w Qobuz",
		"moreplaylisttrack": "Odkryj więcej w Qobuz",
		"readfocus": "Przeczytaj ten artykuł specjalny w Qobuz",
		"seeSubscribes": "Zobacz oferty subskrypcji",
		"cookies": "Ustawienia plików cookie"
	},
	"infos": {
		"trackCount": "{count} utworów",
		"label": "Wytwórnia: {label}",
		"composer": "Kompozytor: {composer}",
		"producers": "Produkcja",
		"mixers": "Miks/mastering",
		"diskCount": "{count} albumów",
		"duration": {
			"long": "{hours} godz. {minutes} min",
			"short": "{minutes} min {seconds} s"
		},
		"playlist": {
			"private": "Prywatna",
			"public": "Publiczna"
		},
		"hires": "Wysoka jakość",
		"available": "Dostępne w"
	},
	"share": {
		"twitter": {
			"track": "Słuchaj {title} od {artist} w Qobuz",
			"album": "Słuchaj {title} od {artist} w Qobuz",
			"artist": "Słuchaj {artist} w Qobuz",
			"playlist": "Słuchaj playlisty {playlist} od {owner} w Qobuz",
			"story": "Przeczytaj ten artykuł w Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} od {artist} jest dostępny w Qobuz!",
				"body": "Słuchaj {title} od {artist} w wysokiej jakości z Qobuz: {url}\n\nQobuz to pierwszy serwis do słuchania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} od {artist} jest dostępny w Qobuz!",
				"body": "Słuchaj {title} od {artist} w wysokiej jakości z Qobuz: {url}\n\nQobuz to pierwszy serwis do słuchania  muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} jest w Qobuz!",
				"body": "Słuchaj {artist} w wysokiej jakości z Qobuz: {url}\n\nQobuz to pierwszy serwis do słuchania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} od {owner} jest dostępna w Qobuz!",
				"body": "Słuchaj playlisty {playlist} od {owner} w wysokiej jakości z Qobuz: {url}\n\nQobuz to pierwszy serwis do słuchania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "Przeczytaj: {url}\n\nQobuz to pierwszy serwis do słuchania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "Kliknij, aby skopiować",
			"copy": "Kopiuj",
			"copied": "Skopiowano",
			"link": "Skopiuj poniższy link, aby go udostępnić"
		}
	},
	"tracklist": {
		"title": {
			"track": "Utwór",
			"album": "Utwory z albumu",
			"artist": "Najlepsze utwory",
			"artist_albums": "Albumy",
			"playlist": "Utwory z playlisty"
		},
		"header": {
			"number": "#",
			"name": "Tytuł",
			"album": "Album",
			"artist": "Artysta",
			"time": "Czas trwania",
			"label": "Wytwórnia"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Brak dostępnych utworów"
	},
	"story": {
		"404": {
			"title": "Artykuł, którego szukasz, nie jest dostępny w Twoim regionie.",
			"description": "Wróć do strony głównej magazynu Qobuz"
		},
		"from": "Autor: {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Dołącz do Qobuz, aby przeczytać cały artykuł...",
		"signUp": "Wypróbuj za darmo"
	},
	"playlist": {
		"from": "Autor: {author}"
	},
	"album": {
		"by": "przez",
		"publishedBy": "wydane przez"
	},
	"notifications": {
		"nostream": "Podmioty praw autorskich nie umożliwiły odtwarzania tego utworu"
	},
	"aside": {
		"title": "O nas"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/pl.json
// module id = 571
// module chunks = 0